<template>
	<div class="form-group" :class="{ 'has-errors' : $parent.form.errors.has(this.name) }">

		<label :for="getFieldId">
			{{ placeholder}}<span v-if="required && isEmpty">*</span>
		</label>

		<div>

			<div class="progress" v-if="file_name">
				<div class="progress-bar progress-bar-success" role="progressbar" :aria-valuenow="0"
					 aria-valuemin="0" aria-valuemax="100" :style="{ width: progress_bar }">
					{{ progress_bar }} Complete
				</div>
			</div>

			<button @click="selectFile" class="btn btn-default" type="button">
				<span v-if="file_name">{{ file_name }}</span>
				<span v-else>Select File</span>
				<i class="fa fa-upload"></i>
			</button>


		</div>

		<input type="file" :name="name" ref="file_input" :id="getFieldId" :required="required">

		<p class="error-label" v-if="$parent.form.errors.has(this.name)" v-text="$parent.form.errors.get(this.name)"></p>

	</div>
</template>

<script>

    let InputField = require('@/mixins/InputField');

    export default {

        mixins: [InputField],

        data() {
            return {
                file_name: "",
                progress_bar: 0,
            }
        },

        mounted() {
            var self = this;
            $('#' + this.getFieldId).on('change', function () {
                self.file_name = this.value.split("\\").pop();
                if (self.$refs.file_input.files.length > 0) {
                    self.uploadFile()
                }
            });
        },

        methods: {

            uploadFile() {
                var data = new FormData();
                data.append('file', this.$refs.file_input.files[0]);
                App.request().post('/filestore', data, {onUploadProgress: this.progressBar}).then(response => {
                    this.$emit('input', response.data.path)
                }).catch(error => {
                    this.$emit('input', '')
                });
            },

            progressBar(event) {
                this.progress_bar = ((event.loaded * 100) / event.total).toFixed(2) + '%';
            },

            selectFile() {
                $('#' + this.getFieldId).click();
            }
        }
    }
</script>
